export default __webpack_public_path__ + "static/media/closing-img.f7e1e77e.png";